import { FC } from "react";

import styles from "./TrendingKeywordsPreview.module.scss";
import { NoWidgetDataStub } from "../../../WidgetTile/components";

export const TrendingKeywordsPreview: FC<Widget.PreviewProps> = ({
  views,
  view,
}) => {
  if (!views.length)
    return (
      <div className={styles.widgetPreview}>
        <NoWidgetDataStub />
      </div>
    );

  return (
    <div className={styles.widgetPreview}>
      <div className={styles.chartWrapper}>{view?.chart}</div>
    </div>
  );
};
